<template>
	<v-card>
		<v-toolbar flat color="dark" dark>
			<v-toolbar-title>
				<span class="pl-2">OSBOD Finance Student</span>
			</v-toolbar-title>
		</v-toolbar>
		<v-card-title>
			<v-text-field v-model="search" append-icon="mdi-magnify" label="Filter" single-line hide-details>
			</v-text-field>
		</v-card-title>

		<v-data-table :headers="headers" :items="data" :search="search" :loading="loading">
			<template v-slot:top>
				<v-toolbar dark dense color="primary" flat class="mb-1">
					<!-- <v-btn depressed class="ml-2" @click="setStudent()" color="inverted">
						<v-icon class="pr-2">mdi-plus-circle</v-icon>Add Student Class
					</v-btn> -->
				</v-toolbar>
			</template>
			<template v-slot:item.action="{ item }">
				<v-icon @click="handleClick(item.id)">mdi-account-edit</v-icon>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
	import Axios from "axios";
	import moment from 'moment';
	//import _ from "lodash";
	import {
		API_ROOT
	} from "../../config";
	console.log(API_ROOT.osbod_salary);
	const ax = Axios.create({
		baseURL: API_ROOT["osbod_salary"],
		timeout: 60000
	});

	export default {
		name: "students",
		// props: ["id"],
		data() {
			return {
				user: JSON.parse(localStorage.getItem("user")),
				student: JSON.parse(localStorage.getItem("student")),
				search: "",
				headers: [{
						text: "",
						align: "center",
						sortable: false,
						value: "action"
					},
			
				{ text: "Government ID", value: "government_id" },
				{ text: "Firstname", value: "firstname" },
				{ text: "Lastname", value: "surname" },
				{ text: "Mobiel", value: "tel_mobile" },
				{ text: "E-mail", value: "email" },
				{ text: "E-mail OSBOD", value: "osbod_email" },
					// { text: "Active", value: "student_active" }

				],
				// semesters: [],
				// studies: [],
				// subjects: [],
				// subjecttypes: [],
				// selected_subject: null,
				// selected_kwalificatie: null,
				// selected_deelkwalificatie: null,
				// selected_semester: null,
				// schoolyear: [],
				// selected_schoolyear: null,
				data: [],
				// banktypes: [],
				isEmpty: false,
				loading: false,
				isPaginated: true,
				isPaginationSimple: false,
				defaultSortDirection: "asc",
				currentPage: 1,
				perPage: 15
			};
		},
		created: function () {
			// this.getBanktypes();
			this.getStudents();
			this.format_date();
		},
		watch: {
			// selected_kwalificatie: function(value) {
			// 	this.getStudySubjecttype(value);
			// 	console.log(value);
			// }
		},
		computed: {


		},
		methods: {
			handleClick(id) {
				this.$router.push({
					path: "/schooladmin/financestudentview/update/" + id
				});
			},
			format_date(value) {
				if (value) {
					return moment(String(value)).format('YYYYMMDD')
				}
			},
			setStudent: function () {
				this.$router.push({
					path: "/schooladmin/financestudentview/new"
				});
			},
			getStudents: function () {
				var self = this;
				this.loading = true;
				ax.get("/student/all").then(function (response) {
					// console.log(self.student.id);
					self.data = response.data;
					console.log("Students fetched...");
					self.loading = false;
				});
			},
			// getBanktypes: function() {
			// 	var self = this;
			// 	ax.get("/banktype/all").then(function(response) {
			// 		console.log(response.data);
			// 		self.banktypes = response.data;
			// 	});
			// }
		}
	};
</script>

<!-- Add "slot-scoped" attribute to limit CSS to this component only -->
<style slot-scoped>
</style>